<app-page-content [showProgress]="loggingIn">
  <span pagetitle>Logg inn</span>

  <form pagecontent [formGroup]="loginForm" (submit)="onLogin()" style="padding: 1em; margin-bottom: 3em;">
    <mat-form-field floatLabel="always" style="width: 100%">
      <mat-label>Brukernavn</mat-label>
      <input matInput formControlName="username" required>
    </mat-form-field>
    <mat-form-field floatLabel="always" style="width: 100%">
      <mat-label>Passord</mat-label>
      <input matInput formControlName="password" type="password" required>
    </mat-form-field>
    <mat-form-field floatLabel="always" style="width: 100%">
      <mat-label>Selskap</mat-label>
      <input matInput formControlName="company" required>
    </mat-form-field>
    <button type="submit" style="visibility: hidden"></button>
  </form>

  <app-button-box pagefooter>
    <button [disabled]="loggingIn" style="margin-right: 0.5em" mat-raised-button color="warn" (click)="close()">AVBRYT</button>
    <button [disabled]="loggingIn" style="margin-right: 0.5em" mat-raised-button color="primary" (click)="onLogin()">LOGG INN</button>
  </app-button-box>
</app-page-content>
